import cx from 'classnames'
import * as React from 'react'

import Button from '@/components/_legacy/Button'
import Paragraph from '../../components/Paragraph/Paragraph'
import { envelope, facebook, linkedIn, print,twitter } from '../../icons'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import { currentSize } from '../../utils/viewport-monitor'
import { windowOpen } from './social.utils'
import styles from './socialShare-style.css'

type Props = {
  /** title: hashtags, label: text to be displayed */
  twitterLink: LinkViewModel

  /** relies on OG data */
  facebookLink: LinkViewModel

  /** title: sets the summary, label: sets the title */
  linkedInLink: LinkViewModel

  /** label is not used, title is used for subject, and href is used for link in email body */
  mailLink: LinkViewModel

  /** sets the twitter username, defaults to @pensam */
  twitterHandle?: string
}

type State = {
  isDesktop: boolean
  ready: boolean
}
const twitterBase = 'https://twitter.com/intent/tweet?url='
const linkedInBase =
  'https://www.linkedin.com/shareArticle?source=https://www.pensam.dk&mini=true&url='

class SocialShare extends React.Component<Props, State> {
  static displayName = 'SocialShare'
  static defaultProps = {}
  state = {
    isDesktop: true,
    ready: false,
  }

  componentDidMount() {
    this.setState({
      isDesktop: currentSize.width > 992 ? true : false,
      ready: true,
    })
  }

  getTwitterUrl = () => {
    if (!!global.encodeURIComponent) {
      const { twitterLink = {}, twitterHandle = 'pensam' } = this.props
      const shareUrl = `${twitterBase}${
        twitterLink.href ? encodeURIComponent(twitterLink.href) : ''
      }${
        twitterLink.label ? `&text=${encodeURIComponent(twitterLink.label)}` : ''
      }&via=${twitterHandle}&lang=dk${twitterLink.title ? `&hashtags=${twitterLink.title}` : ''}`

      return shareUrl
    }

    return '#'
  }
  getLinkedInUrl = () => {
    if (!!global.encodeURIComponent) {
      const { linkedInLink = {} } = this.props
      const shareUrl = `${linkedInBase}${encodeURIComponent(linkedInLink.href || '')}${
        linkedInLink.label ? `&title=${encodeURIComponent(linkedInLink.label)}` : ''
      }${linkedInLink.title ? `&summary=${linkedInLink.title}` : ''}`

      return shareUrl
    }

    return '#'
  }

  render() {
    const { linkedInLink, facebookLink, twitterLink, mailLink } = this.props
    if (!this.state.isDesktop) return null

    if (!linkedInLink && !facebookLink && !twitterLink && !mailLink) {
      return null
    }

    return (
      <div className={cx(styles.socialShare, this.state.ready && styles.ready)}>
        <Paragraph tag="span" className={styles.shareHeading} marginBottom="none">
          Del:
        </Paragraph>
        {!!linkedInLink && (
          <Button
            icon={linkedIn}
            className={styles.icon}
            onClick={() => windowOpen(this.getLinkedInUrl())}
            flat
            iconOnly
            eventMeta={{
              event: 'social-share',
              eventData: 'linkedin',
              eventLabel: this.getLinkedInUrl(),
            }}
          />
        )}
        {!!facebookLink && (
          <Button
            icon={facebook}
            className={styles.icon}
            onClick={() =>
              windowOpen(
                `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  facebookLink.href || '',
                )}&amp;src=sdkpreparse`,
              )
            }
            flat
            eventMeta={{
              event: 'social-share',
              eventData: 'facebook',
              eventLabel: facebookLink.href || '',
            }}
          />
        )}
        {!!twitterLink && (
          <Button
            icon={twitter}
            onClick={() => windowOpen(this.getTwitterUrl())}
            className={styles.icon}
            flat
            eventMeta={{
              event: 'social-share',
              eventData: 'twitter',
              eventLabel: this.getTwitterUrl(),
            }}
          />
        )}
        {!!mailLink && mailLink.title && mailLink.href && (
          <Button
            icon={envelope}
            flat
            className={styles.icon}
            href={`mailto:?subject=${mailLink.title}&body=${mailLink.href}`}
          />
        )}
        <Paragraph tag="span" className={styles.shareHeading} marginBottom="none">
          Print:
        </Paragraph>
        <Button
          icon={print}
          onClick={() => window.print()}
          flat
          className={cx(styles.icon, styles.print)}
          eventMeta={{
            event: 'print',
          }}
        />
      </div>
    )
  }
}

export default SocialShare
